import { ComboBox, Stack } from '@fluentui/react';
import { observer } from 'mobx-react';
import { ProvisionProfileEditorState } from './ProvisionProfileEditor';
import { InfoTooltipLabel } from '../../controls/InfoTooltipLabel';
import ContentMetadataFieldsList from '../content-metadata-fields/ContentMetadataFieldsList';

function ProfileWorkspaceMetadata({ state }: { state: ProvisionProfileEditorState }) {

	let contentTypesOptions = state.availableContentTypes.map((c) => {
		return {
			key: c.id,
			text: c.name
		};
	});

	return (<>
			<Stack>

				<InfoTooltipLabel label='Content Hub Types' title='Content types can be pulled from the hub to the content. These will be applied before other templated content is applied.'>

					<ComboBox selectedKey={state.ContentTypeIds} 
							options={contentTypesOptions}
							multiSelect={true} 
							onChange={((_,o) => { 
								let key = (o?.key || '').toString();
								if(key) {
									state.selectContentTypeId(key, !!o?.selected) 
								}
					})}/>

					<ContentMetadataFieldsList state={state.metadataFields}/>
							
				</InfoTooltipLabel>
			</Stack>
		</>
	);
}

export default observer(ProfileWorkspaceMetadata);
